import { useReadContract } from "wagmi";
import { COLOR_WHEEL_ADDRESS, contractsConfigured } from "../lib/chain";
import { COLORS, colorWheelAbi } from "../lib/contracts";
import type { RecentRound } from "./BetLog";

type Props = {
  refreshKey?: number;
  /** When set, show this local history instead of chain data. */
  override?: RecentRound[];
};

const GREEN = COLORS[0].hex;

export function Ticker({ refreshKey = 0, override }: Props) {
  const { data } = useReadContract({
    address: COLOR_WHEEL_ADDRESS,
    abi: colorWheelAbi,
    functionName: "getRecentRounds",
    query: { enabled: contractsConfigured && !override, refetchInterval: 10_000 },
    scopeKey: `ticker-${refreshKey}`,
  });

  const rounds = override ?? (data as RecentRound[] | undefined) ?? [];
  const last = rounds[0];

  return (
    <div className="ticker" aria-label="Recent spin results">
      <span
        className="ticker-last"
        title={
          last
            ? `Round #${last.roundId.toString().slice(-5)} · GREEN on P${last.result + 1}`
            : ""
        }
      >
        <span className="ticker-last-label">LAST SPIN</span>
        {last ? (
          <span className="ticker-pos" style={{ background: GREEN }}>
            P{last.result + 1}
          </span>
        ) : (
          <span className="ticker-empty">none yet</span>
        )}
      </span>

      <div className="ticker-dots">
        {rounds.map((r) => (
          <span
            key={r.roundId.toString()}
            className={`ticker-pos sm ${r.won ? "won" : "cold"}`}
            title={`Round #${r.roundId.toString().slice(-5)} · GREEN on P${r.result + 1}${
              r.won ? " · paid" : ""
            }`}
          >
            {r.result + 1}
          </span>
        ))}
      </div>
    </div>
  );
}
